module.exports = __webpack_public_path__ + "static/community-dotted-world-map-d3583cb75e481e1e7011283a0a3a43a6.svg";